import React from 'react';
import { useEffect, useState } from "react";
import axios from "axios";
// import SVG from 'react-inlinesvg';

const SingleServices = () => {
    const [services, setServices] = useState([]);

    // eslint-disable-next-line no-undef
    let { bookingParkId, language, apiBaseUrl, mediaBaseUrl } = pluginGlobals;
    const parksApiBase = `${apiBaseUrl || 'https://api.bestpark.fi'}/parks`;
    const amenitiesMediaBase = `${mediaBaseUrl || 'https://uploads.bestpark.fi'}/uploads/amenities`;
    // #region agent log
    fetch('http://localhost:7710/ingest/9db838d3-4f8b-4779-a962-9767ddff3b5d',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'ba29f5'},body:JSON.stringify({sessionId:'ba29f5',runId:'pre-fix',hypothesisId:'H1-H5',location:'SingleServices.js:init',message:'services widget URLs',data:{parksApiBase,amenitiesMediaBase},timestamp:Date.now()})}).catch(()=>{});
    // #endregion

    // eslint-disable-next-line no-undef
    if (!bookingParkId && bookingPageSelectedPark && bookingPageSelectedPark > 0) {
        // eslint-disable-next-line no-undef
        bookingParkId = bookingPageSelectedPark;
    }

    useEffect(() => {
        if (!bookingParkId || !language) return;

        axios.get(`${parksApiBase}/${bookingParkId}/amenities?lang=${language}`)
            .then((response) => {
                setServices(response.data);
            });
    },[bookingParkId, language, parksApiBase]);

    // <SVG src={`${amenitiesMediaBase}/${service.icon}`} width={24} height="auto" title="Menu" />

    return (
        <div>
            <ul className="park-services__list">
                {services && services.map(service => {
                    return (
                        <li>
                            <span>
                                <img src={`${amenitiesMediaBase}/${service.icon}`} alt=""/>
                            </span>
                            {service.name}
                        </li>
                    )
                })}
            </ul>
        </div>);
}

export default SingleServices;
